function FullScreen(props) {
  return (
    <div className="screen">
      {props.children}
    </div>
  )
}

export default FullScreen
